import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const FinalCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative overflow-hidden" data-testid="final-cta-section">
      <motion.img
        src="/images/cta-bg.jpg"
        alt="Floral buttercream custom cake"
        loading="lazy"
        style={{ y, scale: 1.25 }}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-[#2D2422]/60" />

      <div className="relative mx-auto max-w-4xl px-5 py-32 text-center sm:px-8 sm:py-40">
        <Reveal>
          <h2 className="font-display text-4xl font-light leading-tight tracking-tight text-[#FDFBF7] sm:text-5xl lg:text-6xl" data-testid="final-cta-headline">
            Let&rsquo;s Create Something Sweet
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-[#FDFBF7]/85 sm:text-lg">
            Have a celebration coming up? Tell us what you&rsquo;re dreaming up and let&rsquo;s create
            a cake made especially for your moment.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <button
            onClick={() => scrollToId("#inquiry")}
            className="btn-primary mt-10 !bg-[#FDFBF7] !text-[#2D2422] hover:!bg-white"
            data-testid="final-cta-btn"
          >
            Request Your Cake <ArrowRight size={16} strokeWidth={1.5} />
          </button>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
